import { IDocumentType, TClientDoc } from '@/types/docTypes';

export function validatingDocWithRole<T extends TClientDoc | IDocumentType>(
  documentTypes: T[],
  currentRole: number,
): T[] {
  if (!currentRole || !documentTypes.length) {
    return documentTypes;
  }
  const pattern = new RegExp(`(^|,)${currentRole}(,|$)`);
  return documentTypes.filter((d: T) => {
    return !d.blockAccessToDocumentType ? true : !pattern.test(d.blockAccessToDocumentType);
  });
}
